import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Préparer chaque séance prend énormément de temps',
  lines: ['Avant chaque cours, vous devez choisir les bons exercices, construire une séance cohérente, adapter les activités au niveau de votre groupe, organiser la progression et préparer tout votre matériel.', 'Résultat : vous passez parfois presque autant de temps à préparer vos cours qu\'à les animer.']
}, {
  emoji: '⚠️',
  title: "Il n'est pas toujours facile de savoir quoi proposer ensuite",
  lines: ['Chaque groupe évolue différemment. Chaque participant possède ses propres capacités. Vous vous posez régulièrement les mêmes questions : Quel exercice choisir aujourd\'hui ? Comment faire progresser ce groupe ? Comment adapter la séance selon les différents niveaux ? Comment éviter de refaire toujours les mêmes cours ?', 'Créer des séances variées, efficaces et adaptées devient rapidement un véritable défi.']
}, {
  emoji: '📚',
  title: 'Vos ressources sont dispersées partout',
  lines: ['Exercices. Séances. Programmes. Formations. Livres. Vidéos. Notes personnelles. Applications. Toutes ces ressources existent...', 'Mais elles sont réparties dans plusieurs dossiers, plateformes ou documents. Au lieu d\'avoir un seul système organisé, vous perdez du temps à chercher ce dont vous avez besoin.']
}, {
  emoji: '😩',
  title: "Votre journée ne s'arrête jamais",
  lines: ['Les cours s\'enchaînent. Les programmes doivent être adaptés. Les évaluations doivent être mises à jour. Les progrès doivent être suivis. Les prochaines séances doivent être préparées.', 'Et une fois votre journée terminée... Il faut encore organiser les cours des jours suivants. Vous êtes devenu professionnel du fitness senior pour accompagner les personnes. Pas pour passer vos soirées à préparer chaque séance.']
}];
export function PainSection() {
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-102" data-mp="p3tsvnbiov55">
      <h2 className="text-2xl sm:text-4xl font-display text-center text-navy mb-2 leading-none" data-id="element-103" data-mp="p3alv1nenr5w">
        Vous vous reconnaissez ?
      </h2>

      <p className="text-[13px] sm:text-base text-ink text-center mb-4 max-w-2xl mx-auto leading-snug" data-id="element-104" data-mp="ytlpen36fyc9">
        Vous aimez accompagner les seniors. Vous aimez les voir devenir plus
        autonomes, plus forts et plus actifs. Mais préparer chaque séance vous
        demande souvent beaucoup plus de temps que prévu.{' '}
        <span className="font-heading font-semibold text-navy" data-id="element-105" data-mp="b399oq1owxb4">
          Que vous travailliez en salle de sport, en association, en
          collectivité, en cabinet ou en cours privés, vous vous reconnaîtrez
          probablement dans ces situations.
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-106" data-mp="1ql1mjb2d13gq">
        {pains.map(pain => <div key={pain.title} className="bg-white p-3.5 rounded-lg border-l-4 border-gold shadow-sm" data-id="element-107" data-mp="1vjctne19szv9">
            <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy mb-1 leading-snug" data-id="element-108" data-mp="25nb2qgugokcw">
              <span aria-hidden="true" data-id="element-109" data-mp="20phz9vkjm4gb">{pain.emoji}</span> {pain.title}
            </h3>
            {pain.lines.map((line, j) => <p key={j} className="text-ink text-[12.5px] sm:text-sm leading-snug mb-1 last:mb-0" data-id="element-110" data-mp="1rwej3fiijdhz" data-mpi={j}>
                {line}
              </p>)}
          </div>)}
      </div>
    </section>;
}